import React from "react";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import T from 'components/common/translations/Translate';
import { connect } from 'react-redux';
import TransHelper from 'components/common/translations/TransHelper';
import classNames from 'classnames';
// import color from "@material-ui/core/colors/amber";
import isWindow from 'components/common/helpers/isWindow';

class AppLink extends React.Component {

  handleOnClick = (event) => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  render() {
    const { children, type, color, locale, className,
      title, to, ...otherProps } = this.props;
    var path, params, transKey;

    if (this.props.toPath) {
      path = this.props.toPath;
    } else {
      if (to === "/") {
        path = to;
      } else {
        if (typeof to === 'object') {
          transKey = to['url'];
          params = to['params'];
        } else {
          transKey = to;
        }
        var pathTranslated = TransHelper.translateRoute(locale, transKey, params);
        path = pathTranslated.replace(":locale", locale);
      }
    }

    // var isActiveUrl = false;
    // if (isWindow) {
    //   isActiveUrl = document.location.pathname === path;
    // }

    return (
      <Link
        className={className}
        onClick={this.handleOnClick}
        title={title}
        to={path}
      >
        {children}
      </Link>
    );
  }
}

function mapStateToProps(state) {
  return {
    locale: state.app.locale
  }
}

export default connect(mapStateToProps)(AppLink);
